import convertCssUnit from './convert-css-unit';

type SidedProp = 'margin' | 'padding';
type BaseValueType = string | number;
type ValueType = BaseValueType | BaseValueType[];

type ShorthandResult<PropName extends SidedProp> = {
  [Key in PropName]: ValueType;
};

export default function convertShorthand<PropName extends SidedProp>(
  propName: PropName,
  value: ValueType,
): ShorthandResult<PropName> {
  return { [propName]: convertCssUnit(value) } as ShorthandResult<PropName>;
}
